import React from 'react';
import { Box, Typography, Grid, Divider } from '@mui/material';
import Navbar from '../Layouts/Navbar';
import { Person } from '@mui/icons-material';

// User data
const userData = {
  societe: "MAJOREL",
  nom: "TEST",
  prenom: "Omar BASRI",
  site: "Toubkal",
  email: "OmarBASRI@stjg.ma",
  telephone: "0677700634",
};

export default function MonCompte() {
  return (
    <>
      <Navbar />
      <Box p={3}>
        {/* Header */}
        <Box display="flex" alignItems="center">
          <Person />
          <Typography variant="h6" ml={1}> MON COMPTE</Typography>
        </Box>

        {/* Content */}
        <Box mt={4}>
          <Grid container spacing={2}>
            {/* Right Section */}
            <Grid item xs={12}>
            <Box display="flex" justifyContent='end'>
              <Box display="flex" flexDirection="column" width="50%">
                <Box display="flex" justifyContent="space-between" mb={2}>
                  <Typography variant="body1" fontWeight='bold'>Société:</Typography>
                  <Typography variant="body2" textAlign="center">{userData.societe}</Typography>
                </Box>
                <Divider sx={{ my: 2 }} />
                <Box display="flex" justifyContent="space-between" mb={2}>
                  <Typography variant="body1" fontWeight='bold'>Nom:</Typography>
                  <Typography variant="body2" textAlign="center">{userData.nom}</Typography>
                </Box>
                <Divider sx={{ my: 2 }} />
                <Box display="flex" justifyContent="space-between" mb={2}>
                  <Typography variant="body1" fontWeight='bold'>Prénom:</Typography>
                  <Typography variant="body2" textAlign="center">{userData.prenom}</Typography>
                </Box>
              </Box>
              </Box>
            </Grid>

            {/* Left Section */}
            <Grid item xs={12}>
            <Box display="flex" justifyContent='start'>
            <Box display="flex" flexDirection="column" width="50%">
                <Box display="flex" justifyContent="space-between" mb={2}>
                  <Typography variant="body1" fontWeight='bold'>Site:</Typography>
                  <Typography variant="body2">{userData.site}</Typography>
                </Box>
                <Divider sx={{ my: 2 }} />
                <Box display="flex" justifyContent="space-between" mb={2}>
                  <Typography variant="body1" fontWeight='bold'>Email:</Typography>
                  <Typography variant="body2">{userData.email}</Typography>
                </Box>
                <Divider sx={{ my: 2 }} />
                <Box display="flex" justifyContent="space-between" mb={2}>
                  <Typography variant="body1" fontWeight='bold'>Téléphone:</Typography>
                  <Typography variant="body2">{userData.telephone}</Typography>
                </Box>
              </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
}